var render, staticRenderFns
import script from "./documentView.vue?vue&type=script&lang=js"
export * from "./documentView.vue?vue&type=script&lang=js"
import style0 from "./documentView.vue?vue&type=style&index=0&id=96d2e98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d2e98c",
  null
  
)

export default component.exports